<template>
	<svg :width="props.width || 21" :height="props.height || 21" class="icon">
		<use xlink:href="#___icon___welfare"></use>
	</svg>
</template>

<script setup lang="ts">
// Props
const props = defineProps<{
	width?: number;
	height?: number;
}>();
</script>
